import axios, { AxiosResponse } from 'axios';


const appID : string= process.env.REACT_APP_ID!

const SERV_BACK: string = process.env.REACT_APP_BACK || '';
const APIACCOUNT = '/api/IResearch/';

export default class Iresearch {

    static async getUnidades(): Promise<any> {
        const body = JSON.stringify({
            
        });
        
        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetUnidades`,
            
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
        
    }


    static async getOds(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAllOds`,
            
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        
        return response1.data;
    }

    static async GetAuthorCountByGender(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAuthorCountByGender`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetInstitutionPublicationsByYear(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetInstitutionPublicationsByYear`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetEspolCitationsByYear(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetEspolCitationsByYear`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetProyectosByUnidad(idUnidad:string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetProyectosTotalCountingByUnidadSaac/${idUnidad}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetByNpubByUnidad(idUnidad: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetByNpublicacionLast7YearsByUnidad/${idUnidad}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    static async GetByNpublicacionByOds(idOds: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetByNpublicacionByOds/${idOds}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    static async GetProyectosByOds(idOds: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetProyectosByOds/${idOds}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    static async GetPublicationsByOds(idOds: string, page: number = 1, titulo?: string): Promise<any> {
        const params: any = {
            page,
            pageSize: 25
        };

        if (titulo) {
            params.titulo = titulo;
        }

        const response: AxiosResponse<any> = await axios.get(
            `${SERV_BACK}${APIACCOUNT}GetPublicationsByOds/${idOds}`,
            {
                params,
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    }


    static async GetProyectoById(id: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetProyectoById/${id}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    

    static async GetPublicacionInfoByDoi(doi: string): Promise<any> {
        const body = JSON.stringify({ "Doi":doi });

        const response: AxiosResponse<any> = await axios.post(
            `${SERV_BACK}${APIACCOUNT}GetPublicacionInfoByDoi`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    }


    static async GetInvestigadoresByUnidad(unit: string, page: number = 1,  name?: string): Promise<any> {
        const params: any = {
            page,
            pageSize: 25
        };

        if (name) {
            params.name = name; 
        }

        const response: AxiosResponse<any> = await axios.get(
            `${SERV_BACK}${APIACCOUNT}GetInvestigadoresByUnidad/${unit}`,
            {
                params,
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response.data; 
    }


    static async GetContratoByScopusId(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetContratoByScopusId/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetAuthorInfo(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAuthorInfo/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    static async GetAuthorDataAndArea(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAuthorDataAndArea/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    static async GetPublicationsByScopusId(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetPublicationsByScopusId/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    

    static async GetCitationsScivalByScopusId(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetCitationsScivalByScopusId/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }
    

    static async GetProyectosAuthorByScopusId(scopusid: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetProyectosAuthorByScopusId/${scopusid}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

     

    static async GetMyPublicationsByScopusId(scopusid: string, page: number = 1, titulo?: string ): Promise<any> {
        const body = JSON.stringify({

        });

        const params: any = {
            page,
            pageSize: 25
        };

        if (titulo) {
            params.titulo = titulo; 
        }


        

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetMyPublicationsByScopusId/${scopusid}`,

            {
                params,



                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    

    static async GetAuthorCountByGenderAndUnit(idUnidad: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAuthorCountByGenderAndUnit/${idUnidad}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    

    static async GetTotalCitaPublicationByUnidadSaac(idUnidad: string): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetTotalCitaPublicationByUnidadSaac/${idUnidad}`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    
    static async GetTopHindex(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetTopHindex`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;

    }


    

    static async GetPublicationsByKeyWord(keyword: string, page: number = 1): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetPublicationsByKeyWord/${keyword}`,

            {
                params: { page, pageSize: 25 },
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }


    

    static async GetColaboradoresEspol(scopusid: string, page: number = 1): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetColaboradoresEspol/${scopusid}`,

            {
                params: { page, pageSize: 25 },
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }

    
    
    static async GetPublicacionInfoByEid(doi: string): Promise<any> {
        const body = JSON.stringify({ "Doi": doi });

        const response: AxiosResponse<any> = await axios.post(
            `${SERV_BACK}${APIACCOUNT}GetPublicacionInfoByEid`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    }

    static async GetAutores(): Promise<any> {
        const body = JSON.stringify({

        });

        const response1: AxiosResponse<any> = await axios.get(`${SERV_BACK}${APIACCOUNT}GetAutores`,

            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;

    }
}